var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.335,20.892h-11.258c-1.302,0-2.358-1.056-2.358-2.358v-7.449c0-1.302,1.056-2.358,2.358-2.358h3.512c.965,0,1.833.588,2.19,1.484l.004.01c.358.896,1.225,1.484,2.19,1.484h3.361c1.302,0,2.358,1.056,2.358,2.358v4.471c0,1.302-1.056,2.358-2.358,2.358Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.266,14.814c-.582-.429-.959-1.12-.959-1.898v-7.449c0-1.302,1.056-2.358,2.358-2.358h3.512c.965,0,1.833.588,2.19,1.484l.004.01c.358.896,1.225,1.484,2.19,1.484h3.361c1.302,0,2.358,1.056,2.358,2.358v1.014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.18bcfa8ed75dcf9e1280b078ee710c03.svg";
export { ForwardRef as ReactComponent };